import { useRichEditorPreset } from "@/containers/editor/presets/preset-rich-editor";

export const useArticleNodePlugins = () => {
  return useRichEditorPreset({ spellCheck: false });
};
